// extracted by mini-css-extract-plugin
export default {"product-image":"ProductTable_product-image__mdqS8","price-col":"ProductTable_price-col__gOjq+"};